import OrderService from "../../services/orders/OrderService";
import CheckInOrderService from '../../services/orders/CheckInOrderService'
import i18n from "../../i18n/index";

import * as moment from 'moment';
export default {
    props: ["status", "providerId", "enabledColumns"],
    data() {
        return {
            showText: true,
            dataPicker: false,
            date: '',
            date2: '',
            search: "",
            showInput: false,
            headers: [{
                id: 0,
                text: i18n.t('headers.shippin-date'),
                sortable: false,
                value: "shippingDate"
            },
            {
                id: 1,
                text: i18n.t('headers.nro-order'),
                sortable: false,
                value: "number"
            },
            {
                id: 3,
                text: i18n.t('headers.patient-document'),
                sortable: false,
                value: "patient_document"
            },
            {
                id: 4,
                text: i18n.t('headers.patient-name'),
                sortable: false,
                value: "patient_name"
            },
            {
                id: 5,
                text: i18n.t('headers.status-order'),
                value: "status",
                sortable: false
            },
            {
                id: 6,
                text: i18n.t('headers.provider'),
                sortable: false,
                value: "provider"
            },
            {
                id: 7,
                text: i18n.t('headers.order-type'),
                value: "type",
                sortable: false
            },
            {
                id: 8,
                text: i18n.t('headers.pending'),
                value: "hasPending",
                sortable: false
            }
                // {
                //     id: 8,
                //     text: 'CITAS',
                //     value: "IsAppointment",
                //     sortable: false
                // }
            ],
            orders: [],
            totalOrders: 0,
            loading: false,
            pagination: {},
            selectedItem: {},
            rowsPerPageItems: [5, 10, 15, 20],
            code: '',
            searchTypes: ['Documento', 'Número de pedido', 'Autorización', 'Nombre del paciente'],
            searchType: 'Documento',
            minDate: moment().format('YYYY-MM-DD')
        };
    },
    computed: {
        customHeaders() {
            return this.enabledColumns ? this.headers.filter(header => this.enabledColumns[header.id]) : this.headers
        }
    },
    mounted() {
        // this.focusInput();
        this.showInputSearchInvoice();
    },
    watch: {
        pagination: {
            handler() {
                if (this.validateFieldsForSearch()) { 
                    this.getOrders();
                }
            },
            deep: true
        }
    },
    methods: {
        // focusInput() {
        //     this.$refs.code.focus();
        //     console.log(this.$refs.code.focus())
        // },
        showColumn(i) {
            return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
        },
        getOrders() {
            const readyForSearch= this.validateFieldsForSearch();
            if(!readyForSearch){
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Debe diligenciar los campos de busqueda'
                })
                return;
            }
            this.loading = true;
            this.orders = [];
            const { page, rowsPerPage } = this.pagination;
            if (this.date !== null & this.date !== undefined && this.date !== '') { 
                if (this.date2 === null || this.date2 === undefined || this.date2 === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha final'
                    })
                    this.loading = false;
                    return
                }
            }
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') { 
                if (this.date === null || this.date === undefined || this.date === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha inicial'
                    })
                    this.loading = false;
                    return
                }
            }
            if (this.date === null || this.date === undefined) {
                this.date = ''
            }
            if (this.date2 === null || this.date2 === undefined) {
                this.date2 = ''
            }
            let searchTypeAux = ''
            if (this.searchType === 'Documento') {
                searchTypeAux = 'Identification'
            } else if (this.searchType === 'Autorización') {
                searchTypeAux = 'Authorization'
            } else if (this.searchType === 'Número de pedido') {
                searchTypeAux = 'Order'
            } else if (this.searchType === 'Nombre del paciente') {
                searchTypeAux = 'NamePatient'
            }
            OrderService.getOrders(
                page - 1,
                rowsPerPage,
                this.search,
                this.status ? this.status : "",
                this.providerId ? this.providerId : "",
                this.date,
                this.date2,
                searchTypeAux
            ).then(data => {
                this.loading = false;
                this.orders = data.data[0];
                this.totalOrders = data.data[1];
            });
        },
        onRowClick(item, shippingFee, slidingScaleFee) {
            this.$emit("row-click", item, shippingFee, slidingScaleFee);
        },
        async onChange(invoice) {
            this.showText = false
            let response = await CheckInOrderService.getIdOrder({ facturaNumber: invoice })
            let idOrder = response.data
            // let order2 = this.orders.find(order => {
            //     return order.id == idOrder
            // })
            let response2 = await OrderService.getOrder(idOrder)
            let order = response2.data
            this.$emit("row-click", order, invoice)
        },
        showInputSearchInvoice() {
            let pathRoute = this.$router.currentRoute.path
            if (pathRoute === '/check-in-order') {
                this.showInput = true
            }
        },
        changeInitialDate() {
            let initialDate = moment(this.date).format('YYYY-MM-DD')
            this.minDate = initialDate
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') {
                if (!moment(this.date2).isSameOrAfter(initialDate)) {
                    this.date2 = this.minDate
                }
            } else {
                this.date2 = this.minDate
            }
        },
        validateFieldsForSearch () {
            let readyForSearch = false
            if (this.search.length > 0 || this.date.length > 0 || this.date2.length > 0) {
                readyForSearch = !readyForSearch
            };
            return readyForSearch
        }
    }
};